import {select, store} from "../../store";

export const getAuthorizationHeader = () =>
  select.adminSession.getAuthorizationHeader(store.getState());

export const getIsResideAdmin = () =>
  select.adminSession.isResideAdmin(store.getState());
